





























































import { Component, Vue, Watch } from 'vue-property-decorator'
import AppSwitch from '@/views/kyc-form/component/AppSwitch.vue'
import { namespace } from 'vuex-class'
import KYCForm from '@company-common/model/kyc-form/KYCForm'
import AppRadioSelection from '@core/components/AppRadioSelection.vue'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import { isUndefined } from 'lodash/fp'
import NetWorth from '@company-common/model/kyc-form/finances/NetWorth'

const kycFormStore = namespace('KYCFormStore')

@Component({
  components: {
    AppSwitch,
    AppRadioSelection,
    AppForm
  }
})
export default class NetWorthView extends Vue {
  selectedClient = 'Client 1';

  @kycFormStore.State
  private kycForm!: KYCForm;

  @kycFormStore.State
  private computedValidationResult: any

  get sectionErrors () {
    return this.computedValidationResult['Net Worth'] || {}
  }

  get netWorthSectionErrors () {
    const errors = this.sectionErrors[this.selectedClient] ? this.sectionErrors[this.selectedClient] : []
    const finalErrors: { key: string; msg: string }[] = []
    errors.map(({ key, message }) => {
      key.map(variableName => {
        finalErrors.push({
          key: variableName,
          msg: message
        })
      })
    })
    return finalErrors
  }

  get sharedNetWorthAttributes () {
    return this.kycForm.client1.netWorth
  }

  get editingClient () {
    if (this.selectedClient === 'Client 1') {
      return this.kycForm.client1.netWorth
    } else {
      return this.kycForm.client2.netWorth
    }
  }

  get client () {
    if (this.selectedClient === 'Client 1') {
      return this.kycForm.client1
    } else {
      return this.kycForm.client2
    }
  }

  clientOptionSelected (option: string): void {
    if (option === 'Client 2' && !this.isClient2Included()) {
      window.alert('Client 2 is not included in this KYC Form. To include, go to "Client Summary" page and enable the checkbox.')
      return
    }
    this.selectedClient = option
  }

  isClient2Included () {
    return this.kycForm.client2.personalDetails.included
  }

  isLockedField (key, clientIndex) {
    const index = clientIndex + 1 // because in kycform, it is client1, client2

    if (isUndefined(this.kycForm['client' + index].myInfo.lockedFields)) {
      return
    }

    return this.kycForm['client' + index].myInfo.keyIsLockedField(key)
  }

  get netWorthPersonalStructure (): FormStructure<NetWorth> {
    return [
      {
        label: 'Cash/ Fixed Deposits/ Cash Equivalents',
        key: 'cash',
        type: 'currency'
      },
      {
        label: 'Residential Property',
        key: 'residentialAssets',
        type: 'currency'
      },
      {
        label: 'Motor Vehicle',
        key: 'motor',
        type: 'currency'
      },
      {
        label: 'Other personal assets (Country club memberships etc.)',
        key: 'otherPersonalAssets',
        type: 'currency'
      },
      {
        label: 'Total Personal Used Assets',
        key: 'totalUsedAssets',
        classes: ['result'],
        disabled: true,
        type: 'currency'
      }
    ]
  }

  get netWorthAssetsStructure (): FormStructure<NetWorth> {
    const clientIndex = this.selectedClient === 'Client 1' ? 0 : 1
    return [
      {
        label: 'Business',
        key: 'investBusiness',
        type: 'currency'
      },
      {
        label: 'Stock Portfolio',
        key: 'stocksShares',
        type: 'currency'
      },
      {
        label: 'Residential/ Commercial property',
        key: 'investProperty',
        type: 'currency'
      },
      {
        label: 'Unit Trust',
        key: 'unitTrust',
        type: 'currency'
      }, {
        label: 'CPF (OA)',
        key: 'cpfOrdinary',
        type: 'currency',
        disabled: this.isLockedField('cpfOrdinary', clientIndex),
        isMyInfo: this.isLockedField('cpfOrdinary', clientIndex)
      }, {
        label: 'CPF (SA)',
        key: 'cpfSpecial',
        type: 'currency',
        disabled: this.isLockedField('cpfSpecial', clientIndex),
        isMyInfo: this.isLockedField('cpfSpecial', clientIndex)
      }, {
        label: 'CPF (RA)',
        key: 'cpfRa',
        type: 'currency'
      }, {
        label: 'CPF (MA)',
        key: 'cpfMedisave',
        type: 'currency',
        disabled: this.isLockedField('cpfMedisave', clientIndex),
        isMyInfo: this.isLockedField('cpfMedisave', clientIndex)
      }, {
        label: 'SRS',
        key: 'srs',
        type: 'currency'
      }, {
        label: 'Life Insurance Cash Value',
        key: 'lifeInsuranceCash',
        type: 'currency'
      }, {
        label: 'Click to add invested asset',
        labelModel: {
          get: () => this.sharedNetWorthAttributes.others1Text,
          set: (value) => { this.sharedNetWorthAttributes.others1Text = value as string }
        },
        key: 'others1',
        type: 'currency'
      }, {
        label: 'Total Invested Assets',
        key: 'totalInvestedAssets',
        classes: ['result'],
        disabled: true,
        type: 'currency'
      }
    ]
  }

  get netWorthCashStructure (): FormStructure<NetWorth> {
    return [
      {
        label: 'Bank Deposits',
        key: 'bankDeposits',
        type: 'currency'
      }, {
        label: 'Click to add cash',
        labelModel: {
          get: () => this.sharedNetWorthAttributes.others5Text,
          set: (value) => { this.sharedNetWorthAttributes.others5Text = value as string }
        },
        key: 'others5',
        type: 'currency'
      }, {
        label: 'Click to add cash',
        labelModel: {
          get: () => this.sharedNetWorthAttributes.others6Text,
          set: (value) => { this.sharedNetWorthAttributes.others6Text = value as string }
        },
        key: 'others6',
        type: 'currency'
      }, {
        label: 'Total Cash / Cash Equivalents',
        classes: ['result'],
        disabled: true,
        type: 'currency',
        model: {
          get: () => {
            this.client.cashFlow.regularSavings = this.editingClient.totalCashAssets.toString()
            return this.editingClient.totalCashAssets
          },
          set: () => ({})
        }
      }
    ]
  }

  get netWorthLiabilitiesStructure (): FormStructure<NetWorth> {
    return [
      {
        label: 'Mortgage Loan',
        key: 'homeMortgage',
        type: 'currency'
      }, {
        label: 'Motor Loan',
        key: 'carLoans',
        type: 'currency'
      }, {
        label: 'Education Loan',
        key: 'educationLoans',
        type: 'currency'
      }, {
        label: 'Income Tax',
        key: 'tax',
        type: 'currency'
      }, {
        label: 'Credit Card Balance/ Overdraft',
        key: 'creditCard',
        type: 'currency'
      }, {
        label: 'Click to add liabilities',
        labelModel: {
          get: () => this.sharedNetWorthAttributes.others7Text,
          set: (value) => { this.sharedNetWorthAttributes.others7Text = value as string }
        },
        key: 'others7',
        type: 'currency'
      }
    ]
  }

  @Watch('sharedNetWorthAttributes.netWorthPlanning')
  planningChanged (newValue: string) {
    if (newValue === 'yes') {
      this.sharedNetWorthAttributes.noPlanningReason = ''
    }
  }
}
